import './Field.css';

export default function Select({ error = false, className = '', children, ...rest }) {
  return (
    <select
      className={`field-control ${error ? 'field-control-error' : ''} ${className}`}
      aria-invalid={error || undefined}
      {...rest}
    >
      {children}
    </select>
  );
}
